import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['more']
  static values = { url: String }

  moreTargetConnected(more) {
    more.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) this.load(more)
    }, { root: more.parentElement, rootMargin: '300px' })
    more.observer.observe(more)
  }

  moreTargetDisconnected(more) {
    more.observer?.disconnect()
  }

  async load(more) {
    more.observer.disconnect()
    const params = new URLSearchParams(window.location.search)
    params.set('stage', more.dataset.nextStage)
    params.set('offset', more.dataset.nextOffset)

    try {
      const response = await fetch(`${this.urlValue}?${params}`, { headers: { Accept: 'text/html' } })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      more.insertAdjacentHTML('beforebegin', await response.text())
      more.remove()
    } catch {
      more.textContent = 'Não foi possível carregar mais leads. Clique para tentar de novo.'
      more.addEventListener('click', () => this.load(more), { once: true })
    }
  }
}
